<ul class="pagination" *ngIf="totalPages">
  <li class="page-item" [ngClass]="{'disabled': currentPage<2}">
    <a class="page-link cursor-pointer" tabindex="-1" aria-disabled="true" (click)="setPage(1)">First</a>
  </li>
  <li class="page-item" [ngClass]="{'disabled': currentPage<2}">
    <a class="page-link cursor-pointer" tabindex="-1" aria-disabled="true" (click)="setPage(currentPage-1)">Previous</a>
  </li>
  <li class="page-item"><a class="page-link cursor-pointer" *ngIf="currentPage>1" (click)="setPage(currentPage-1)">{{currentPage-1}}</a></li>
  <li class="page-item active" aria-current="page"><a class="page-link cursor-pointer" (click)="setPage(currentPage)">{{currentPage}}</a></li>
  <li class="page-item"><a class="page-link cursor-pointer" *ngIf="currentPage<totalPages" (click)="setPage(currentPage+1)">{{currentPage+1}}</a></li>
  <li class="page-item" [ngClass]="{'disabled': currentPage==totalPages}">
    <a class="page-link cursor-pointer" (click)="setPage(currentPage+1)">Next</a>
  </li>
  <li class="page-item" [ngClass]="{'disabled': currentPage==totalPages}">
    <a class="page-link cursor-pointer" (click)="setPage(totalPages)">Last</a>
  </li>
</ul>
